// extracted by mini-css-extract-plugin
module.exports = {"spotConvert":"spot_spotConvert__tHCkX"};